(() => {
  const DAY = 86400000;
  const DISMISS_DAYS = 14;
  const SUBSCRIBED_DAYS = 90;
  const DISMISS_KEY = 'glitzSalePopupDismissedAt_v2';
  const SUBSCRIBED_KEY = 'glitzSalePopupSubscribedAt_v2';

  const params = new URLSearchParams(window.location.search);
  const forcePopup = params.get('glitz_popup') === '1';

  const readTime = (key) => {
    try {
      const value = Number(localStorage.getItem(key));
      return Number.isFinite(value) ? value : 0;
    } catch (_) {
      return 0;
    }
  };

  const writeTime = (key) => {
    try {
      localStorage.setItem(key, String(Date.now()));
    } catch (_) {}
  };

  const withinDays = (timestamp, days) => timestamp && Date.now() - timestamp < days * DAY;

  const init = () => {
    const popup = document.querySelector('[data-glitz-sale-popup]');
    if (!popup) return;
    const path = window.location.pathname.replace(/\/+$/, '');
    const contactPage = [
      '/pages/visit-our-showroom',
      '/pages/contact',
      '/pages/contact-us'
    ].includes(path) || path.startsWith('/blogs/showroom-guides/');
    if (contactPage && !forcePopup) return;

    const endDate = new Date(popup.dataset.endDate || '');
    if (!Number.isNaN(endDate.getTime()) && Date.now() >= endDate.getTime()) {
      popup.remove();
      return;
    }

    const success = popup.dataset.success === 'true';
    const panel = popup.querySelector('.glitz-sale-popup__panel');
    const focusTarget = popup.querySelector('.glitz-sale-popup__close');
    let previouslyFocused = null;
    let closeTimer = null;

    const open = () => {
      window.clearTimeout(closeTimer);
      previouslyFocused = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('glitz-popup-open');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          popup.classList.add('is-open');
          window.setTimeout(() => focusTarget?.focus(), 360);
        });
      });
    };

    const close = (remember = true) => {
      if (remember && !forcePopup) writeTime(DISMISS_KEY);
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('glitz-popup-open');

      closeTimer = window.setTimeout(() => {
        popup.hidden = true;
        if (previouslyFocused instanceof HTMLElement) previouslyFocused.focus();
      }, 430);
    };

    popup.querySelectorAll('[data-glitz-popup-close]').forEach((el) => {
      el.addEventListener('click', () => close(true));
    });

    document.addEventListener('keydown', (event) => {
      if (!popup.hidden && event.key === 'Escape') close(true);
    });

    panel?.addEventListener('click', (event) => event.stopPropagation());

    if (success) {
      writeTime(SUBSCRIBED_KEY);
      open();
      return;
    }

    if (forcePopup) {
      window.setTimeout(open, 500);
      return;
    }

    const alreadySubscribed = withinDays(readTime(SUBSCRIBED_KEY), SUBSCRIBED_DAYS);
    const recentlyDismissed = withinDays(readTime(DISMISS_KEY), DISMISS_DAYS);

    if (!alreadySubscribed && !recentlyDismissed) {
      window.setTimeout(open, 5000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();